module.exports = __webpack_public_path__ + "static/media/TALKATIVE.e6ced4f8.svg";